import { RG_TYPE } from '../../types/rg-type.js';

const DefaultGlazing = {
    type: RG_TYPE.Glazing,
    size: [1, 1, 0.11],
    anchor: [0.5, 0, 0.5],
    name: 'glazing element',
    children: [],
    color: '#4469BE',
    alpha: 0.5
};

export { DefaultGlazing };
//# sourceMappingURL=default-glazing.js.map
